import { StepValidationState } from "../../../../../interfaces/step";
import { SearchStepper } from "../search-stepper";
import { BusinessReportReviewComponent } from "projects/reg-hub-client/src/app/orders/business-report-review/business-report-review.component";

// International (Kyckr) business reports are always ordered from a business search result, which already carries the
// company's number and name, so there are no report criteria to enter.
export class _IBusinessReportStepper extends SearchStepper {

    constructor() {
        super()

        this.steps = [
            { title: "Review", content: BusinessReportReviewComponent, validationState: StepValidationState.DefaultState }
        ];
    }
}
